export const Translations_NO = {
	footer: {
		join: "Bli med i denne diskusjonen nå. Ingen app eller pålogging kreves.",
		climate: "En klimapositiv diskusjon.",
		tree: "De Treet er plantet.",
		start: "Start video diskusjoner gratis.",
	},
};
